import { atom } from 'jotai';

import { readOnlyAtom } from '../utils/utils';

const writableAtom = atom('America/New_York');
// Read-only atom
export const timeZoneAtom = readOnlyAtom(writableAtom);
